import {useEffect} from "react";
import {get} from "../api/api";
import {useAppStore} from "../store/appStore";
import {useAuthStore} from "../store/authStore";
import {showMessage} from "../utils/snackbar";

export const useTemplatesInit = () => {

    // const userModel = useAppStore((state) => state.userModel);
    const idToken = useAuthStore((state) => state.idToken);
    const userModel = useAppStore(state => state.userModel)
    const templates = useAppStore(state => state.templates)


    useEffect(() => {
        const fetchTemplates = async () => {
            if (!idToken || !userModel) return;
            if (templates?.length > 0) return;

            try {
                console.info("[useTemplatesInit] Fetching templates for user model:", userModel);
                const templates = await get("/templates");
                useAppStore.setState({templates: templates});
            } catch (error) {
                console.warn("[useTemplatesInit] Failed to fetch templates:", error);
                showMessage("Er is een fout opgetreden bij het ophalen van de templates.", "error");
            }
        }

        fetchTemplates();

    }, [idToken, userModel]);
};
